import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useCountryChannelBreakdownKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [ordGmvVal, ordNum, avgOrdGmvVal, retQtyRate, netSlsGmvVal] = getMeasures([
    'ordGmvVal',
    'ordNum',
    'avgOrdGmvVal',
    'retQtyRateExpOD',
    'netSlsGmvValExpOD',
  ]);

  return [
    customKpi('share_per_channel', {
      titleId: 'insights.marketplace_tab.marketplace_channel_breakdown.report.share_per_channel',
      descriptionId: 'insights.marketplace_tab.marketplace_channel_breakdown.report.share_per_channel_description',
    }),
    measureKpi(ordGmvVal),
    measureKpi(ordNum),
    measureKpi(avgOrdGmvVal),
    measureKpi(retQtyRate),
    measureKpi(netSlsGmvVal),
  ];
}

export function CountryChannelBreakdownInfoContent() {
  const kpis = useCountryChannelBreakdownKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.report.country_channel_breakdown.why_is_it_useful"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
